import axios from "axios";

/**
 * @param {HTMLDom} dom
 * @param {sectionsArray} sectionsArray
 * renders product filters
 */
const renderSections = (dom, sectionsArray) => {
  sectionsArray.forEach((section) => {
    const source = dom.querySelector(section);
    const destination = document.querySelector(section);
    destination.outerHTML = source.outerHTML;
  });
};

let productObject = [];
const cartSectionId = document.querySelector(".cart-drawer__inner");

const handleAdditionalgoodies = async (goodies) => {
  const body = {
    sections: [cartSectionId.dataset.sectionId],
    attributes: {},
  };
  goodies.forEach((id) => {
    body.attributes[`${id.title}`] = id.id;
  });

  try {
    await axios({
      method: "post",
      url: "/cart/update.js",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-Requested-With": "xmlhttprequest",
      },
      data: JSON.stringify(body),
    }).then((response) => {
      const responseData = response.data;
      const parser = new DOMParser();
      const dom = parser.parseFromString(
        responseData.sections["cart-drawer"],
        "text/html"
      );
      const sectionArray = [".selected-goodie"];
      renderSections(dom, sectionArray);
      removeGoodies();
    });
  } catch (error) {
    console.log(error.response.status);
  }
};

const belowThreshold = (checkbox, checkboxButtons) => {
  if (checkbox.dataset.threshold === "true") {
    // Clear other checkboxes and their IDs
    let amountOfcheckedBoxes = 0;

    checkboxButtons.forEach((boxChecked) => {
      if (boxChecked.classList.contains("checked")) {
        amountOfcheckedBoxes = amountOfcheckedBoxes + 1;
        // if the checkbox is checked, add 1 to the amount of checked boxes
      }
    });
    checkboxButtons.forEach((otherCheckbox) => {
      if (otherCheckbox !== checkbox) {
        const otherId = otherCheckbox.value.split("| ")[1];
        const otherTitle = otherCheckbox.value.split("| ")[0].trim();
        const otherItemIndex = productObject.findIndex(
          (item) => item.title === otherTitle
        );

        if (otherItemIndex !== -1) {
          if (amountOfcheckedBoxes > 1) {
            // if the amount of checked boxes is more than 1, clear the other checkboxes
            productObject[otherItemIndex].id = ""; // Clear the ID
            otherCheckbox.checked = false;
            otherCheckbox.classList.remove("checked");
          }
        }
        handleAdditionalgoodies(productObject);
      }
    });
  }
};

export const handleGoodieListenersCheckbox = () => {
  const checkboxButtons = document.querySelectorAll(
    'input[name="attributes[__selectable-gifts]"]'
  );

  const selectedGoodies = document.querySelectorAll(".goodie-selected");

  selectedGoodies.forEach((goodie) => {
    checkboxButtons.forEach((checkbox) => {
      if (goodie.dataset.productId === checkbox.value.split("| ")[1]) {
        checkbox.checked = true;
        checkbox.classList.add("checked");
      }
    });
  });

  checkboxButtons.forEach((checkbox) => {
    belowThreshold(checkbox, checkboxButtons);

    checkbox.addEventListener("change", () => {
      const id = checkbox.value.split("| ")[1];
      const title = checkbox.value.split("| ")[0].trim();

      const item = {
        id: id,
        title: title,
      };

      const existingItemIndex = productObject.findIndex(
        (item) => item.title === title
      );

      if (checkbox.checked) {
        if (existingItemIndex !== -1) {
          // Remove existing item with the same title
          productObject.splice(existingItemIndex, 1);
        }
        productObject.push(item);
        checkbox.classList.add("checked");
      } else {
        // Uncheck and clear the ID of the unchecked item
        productObject = productObject.filter((item) => item.id !== id);
        checkbox.classList.remove("checked");
      }

      if (checkbox.dataset.threshold === undefined) {
        handleAdditionalgoodies(productObject);
      } else {
        belowThreshold(checkbox, checkboxButtons);
      }
      // handleAdditionalgoodies(productObject);
    });
  });


};

handleGoodieListenersCheckbox();




const populateInitialProductObject = () => {
  const goodieSelected = document.querySelectorAll(".goodie-selected");
  goodieSelected?.forEach((goodie) => {
    const id = goodie.dataset?.productId;
    const title = goodie.dataset?.name;

    const item = {
      id: id,
      title: title,
    };

    productObject.push(item);
    const checkboxButtons = document.querySelectorAll(
      'input[name="attributes[__selectable-gifts]"]'
    );
    checkboxButtons.forEach((checkbox) => {
      if (checkbox.value.split("| ")[1] === id) {
        checkbox.checked = true;
        checkbox.classList.add("checked");
      }
      // if product id matches checkbox value, check the checkbox and add the class checked
    });
  });
};

const removeGoodies = () => {
  const removeGoodieButtons = document.querySelectorAll(".remove-goodie");
  removeGoodieButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const checkboxButtons = document.querySelectorAll(
        'input[name="attributes[__selectable-gifts]"]'
      );

      checkboxButtons.forEach((checkbox) => {
        if (checkbox.value.split("| ")[1] === button.dataset.goodieid) {
          const id = checkbox.value.split("| ")[1];
          // Remove the item from productObject based on the ID
          productObject.forEach((item) => {
            if (item.id === id) {
              item.id = "";
            }
          });
          checkbox.checked = false;
          checkbox.classList.remove("checked");
        }
      });
      // Remove duplicates from productTitles array
      handleAdditionalgoodies(productObject);
    });
  });
};

populateInitialProductObject();
removeGoodies();
